// src/config/entityColors.js
/**
 * The colour a project or tag falls back to before anyone picks one.
 *
 * This is DATA, not styling — it stands in for a value the user chooses and is
 * stored on the record — which is why it lives here rather than in theme.css,
 * and why it doesn't move with the theme. It was written out as a bare
 * `'#808080'` in four different components.
 */
export const DEFAULT_ENTITY_COLOR = '#808080';
